<template>
  <div class="ai-footer">
    <div class="inner clearfix">
      <section class="footer-left">
          <div class="site-logo">
            <span><img :src="require('@/assets/imgs/logo.svg')" alt=""></span>
            <!-- <span>大数据·<span class="dark">AI</span></span> -->
          </div>
          <div class="site-nav">
            <div class="list">
              <router-link to="./index"><span>首页</span></router-link>
              <router-link to="./index"><span>产品</span></router-link>
              <router-link to="./index"><span>解决方案</span></router-link>
              <router-link to="./index"><span>信也科技杯</span></router-link>
              <router-link to="./index"><span>合作与社区</span></router-link>
            </div>
            <div class="tips">Copyright Reserved 2007-2020©拍拍贷 | <a target="_blank" href="//www.beian.miit.gov.cn ">沪ICP备05063398号</a> | 上海拍拍贷金融信息服务有限公司</div> 
          </div>
      </section>
      <section class="footer-right">
          <ul class="site-info">
            <li><i class="icon icon-footer-email"></i>邮箱：cbd@ppdai.com</li>
            <li><i class="icon icon-footer-email"></i>地址：上海市浦东新区丹桂路999号</li>
          </ul>
          <div class="site-code">
            <img :src="require('@/assets/imgs/qrcode.png')" alt=""> 
          </div>
      </section>
    </div>
  </div>
</template>
<script charset="utf-8">
import { reactive, onMounted, toRefs, nextTick } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'Footer',
  components: {
  },
  setup() {
    const router = useRouter()
    const state = reactive({
      isFooter: true,
    });
    return {
      ...toRefs(state),
    };
  }
}
</script>
<style scoped lang="scss">
  .ai-footer{
    background: #2E3449;
    color: #6E778F;
    .inner{
      width: 1180px;
      margin: 0 auto;
      display: flex;
      .footer-left{
        flex: 1;
        display: flex;
        align-items: center;
        height: 150px;
        .site-logo{
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: center;
          line-height: 16px;
          float: left;
          width: 130px;
          .dark{
            color: #467CFD;
          }
          img{
            width: 72px;
          }
        }
        .site-nav{
          flex: 1;
          .list{
            padding: 0 0 14px 0;
            a{
              margin: 0 30px 0 0;
              font-family: PingFangSC-Regular;
              font-size: 13px;
              color: #CCD2E1;
              letter-spacing: 0;
              line-height: 13px;
            }
          }
          .tips{
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #6E778F;
            line-height: 12px;
            a{
              color: #6E778F;
            }
          }
        }
      }
      .footer-right{
        width: 330px;
        height: 150px;
        display: flex;
        align-items: center;
        .site-info{
          flex: 1;
          li{
            margin: 0 0 13px 0;
            font-family: PingFangSC-Regular;
            font-size: 13px;
            color: #6E778F;
            line-height: 13px;
            &:last-child{
              margin: 0;
            }
          }
        }
        .site-code{
          width: 110px;
          img{
            width: 80px;
          }
        }
      }
    }
  }
</style>
